import ProjectService from './impl/ProjectService.impl'
import SnapshotService from './impl/SnapshotService.impl'
import { IProjectService } from './IProjectService'
import { ISnapshotService } from './ISnapshotService'
import { UploadService } from './impl/UploadService.impl'
import { IGlobalFilterService } from '@/services/IGlobalFilterService'
import GlobalFiltersService from './impl/GlobalFilterService.impl'
import CustomMetricService from './impl/CustomMetricService.impl'
import { ICustomMetricService } from './ICustomMetricService'
import RestArtifactService from './impl/ArtifactService.rest.impl'
import { IArtifactService } from './IArtifactService'
import ProviderIconService from './impl/ProviderIconService.impl'
import ChartService from './impl/ChartService.impl'
import ColorConverterService from './impl/ColorConverterService.impl'
import SearchService from './impl/SearchService.impl'
import DashboardService from './impl/DashboardService.impl'
import RappidContext from '@/pages/explorer/rappid/rappid-context'
import GlobalFilterToolboxService from './impl/GlobalFiltersToolboxService'
import RouteParamValidator from './impl/RouteParamValidator.impl'
import RouteStoreSync from './impl/RouteStoreSync.impl'
import { IRouteParamValidator } from './IRouteParamValidator'
import { IRouteStoreSync } from './IRouteStoreSync'

export class FactoryManager {
  constructor(
    private backendUrl: string,
    private platformUrl: string,
  ) {}

  createUploadService(): UploadService {
    return new UploadService(this.backendUrl)
  }

  createProjectService(): IProjectService {
    return new ProjectService(this.backendUrl)
  }

  createSnapshotService(): ISnapshotService {
    return new SnapshotService(this.backendUrl)
  }

  createGlobalFilterService(): IGlobalFilterService {
    return new GlobalFiltersService(this.backendUrl)
  }
  createGlobalFilterToolboxService() {
    return new GlobalFilterToolboxService(this.backendUrl)
  }
  createCustomMetricService(): ICustomMetricService {
    return new CustomMetricService(this.backendUrl)
  }
  createArtifactService(): IArtifactService {
    return new RestArtifactService(this.backendUrl)
  }
  createProviderIconService() {
    return new ProviderIconService()
  }
  createChartService() {
    return new ChartService()
  }
  createDashboardService() {
    return new DashboardService()
  }
  createColorCoverterService() {
    return new ColorConverterService()
  }
  createSearchService() {
    return new SearchService()
  }
  createRappidContext() {
    return new RappidContext()
  }

  createRouteParamValidator(
    projectSVC: IProjectService,
    snapshotSVC: ISnapshotService,
    artifactSVC: IArtifactService,
    globalfilterSVC: IGlobalFilterService,
  ): IRouteParamValidator {
    return new RouteParamValidator(projectSVC, snapshotSVC, artifactSVC, globalfilterSVC)
  }

  createRouteStoreSync(routeParamValidator: IRouteParamValidator): IRouteStoreSync {
    return new RouteStoreSync(routeParamValidator)
  }
}
